import { render, staticRenderFns } from "./LinkFields.vue?vue&type=template&id=95912cfa&scoped=true&"
import script from "./LinkFields.vue?vue&type=script&lang=js&"
export * from "./LinkFields.vue?vue&type=script&lang=js&"
import style0 from "./LinkFields.vue?vue&type=style&index=0&id=95912cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95912cfa",
  null
  
)

export default component.exports